module.exports = __webpack_public_path__ + "assets/img/sort-value.f34f516a.svg";